import { createNetworkActions } from "~/utils/actions";

export default {
	...createNetworkActions("HOLDINGS_HISTORY"),
};
